import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { ClearingHouseBO, ColumnChangeBO, columnWidth, functionpermission, GetListBase, WhereCondition } from './clearing-house.model';
import { ClearingHouseService } from './clearing-house.service';
import { GetHTTPService } from './clearing-housing-table.service';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { SearchSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { CommonHttpService } from 'src/app/common.service';
import { DropList } from '../users/users.model';

@Component({
  selector: 'app-clearing-house',
  templateUrl: './clearing-house.component.html',
  styleUrls: ['./clearing-house.component.scss']
})
export class ClearingHouseComponent implements OnInit {
  @ViewChild('grid') public grid: GridComponent;
  isSaveorUpdateBoolean:boolean=false;
  private onDestroy$: Subject<void> = new Subject<void>();
  ClearH: ClearingHouseBO = new ClearingHouseBO();
  CHSendBO: GetListBase = new GetListBase();
  conditionData: WhereCondition = new WhereCondition();
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  fp: functionpermission = new functionpermission();

  arraycol: any = [];
  Clearing_House_Array: ClearingHouseBO[];
  ClearingDataList: any = [];
  ColumnArray: columnWidth[];
  valuechange: any = [];
  conditionlist: WhereCondition[] = [];
  senderidQualifier = [];
  RecieveridQualifier = [];
  stateList: any = [];
  public toolbar: ToolbarItems[];

  clearHouseForm: FormGroup;
  SearchText: string = '';
  SearchColumn: { [key: string]: string } = { 'name': 'Name' };
  dropInstance: DropDownList;
  public searchSettings: SearchSettingsModel;
  initialPage: object;
  filterOptions: FilterSettingsModel;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  ClearingHouseFilterstatus: string = "Active";

  clearinghouseStatus: string;
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;

  ModelType: string = 'edit';
  type: string = "";
  deleteId: string = '';
  index: number;
  id: number = 0;

  constructor(public formBuilder: FormBuilder, @Inject(GetHTTPService) public gethttp: GetHTTPService,
    public global: GlobalComponent, public httpService: ClearingHouseService, public toastrService: ToastrService,
    private ngxService: NgxUiLoaderService, public commonhttp: CommonHttpService) {
    this.data = gethttp;
    // ============================Form Initialization===========================//

    this.clearHouseForm = this.formBuilder.group({
      Name: [' ', Validators.required],
      ReceiverIDQualifierLid: [' ', Validators.required],
      ReceiverID: [' ', Validators.required],
      SenderID: [' ', Validators.required],
      SenderIDQualifier: [' ', Validators.required],
      TradingPartner: [' ', Validators.required],
    });
  }

  ngOnInit(): void {
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }

    this.conditionlist.push(new WhereCondition());
    this.toolbar = ['ColumnChooser'];
    this.SearchColumn.key = 'name';
    this.SearchColumn.value = 'name';
    this.filterOptions = { type: 'Menu' };
    this.initialPage = {
      currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes
    };
    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });
    this.getReceiver_id_qualifier();
    this.getSenderIdQualifier();
    this.getClearingHouse();
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Clearing-House");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.httpService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }


  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.CHSendBO.orderColumn = state.sorted[0].name;
        this.CHSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.CHSendBO.field = state.action.currentFilterObject.field;
      this.CHSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.CHSendBO.operator = state.action.currentFilterObject.operator;
      this.CHSendBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.CHSendBO.field = "name";
        this.CHSendBO.matchCase = false;
        this.CHSendBO.operator = "startswith";
        this.CHSendBO.value = "";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Clearinghouse.Pagesize != state.take) {
          this.arraycol[0].Clearinghouse.Pagesize = state.take
        }

      }
    }

    this.getClearingHouse();
    if (this.type == "paging" && state.action.name == "actionBegin") {
    }
  }

  onResize(args) {
    const column = this.grid.getColumnByField(args.column.field)
    column.width = args.column.width;

    this.ColumnArray.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }

    });
  }

  checkpopup(value) {

    if (value == "Name") {
      this.valuechange.Name++;
    }
    if (value == "tradingPartnerId") {
      this.valuechange.tradingPartnerId++;
    }
    if (value == "SenderID") {
      this.valuechange.senderId++;
    }
    if (value == "SenderIDQualifierLid") {
      this.valuechange.SenderIDQualifierLid++;
    }
    if (value == "ReceiverID") {
      this.valuechange.receiverId++;
    }
    if (value == "ReceiverIDQualifierLid") {
      this.valuechange.ReceiverIDQualifierLid++;
    }
  }
  // ==================== Create and update Clearing House ================== //
  OpenCreateupdate(type: string) {
    if (type == 'new') {
      this.ModelType = 'new';
      this.clearinghouseStatus = "saveActive";
      this.clearHouseForm.reset();
      this.ClearH = new ClearingHouseBO();
      this.clearHouseForm.setControl('ClearingHousePayorMapping', new FormArray([]));
    }
    else {
      this.ModelType = 'edit';
    }
  }

  closeAddUpdateModal() {
    document.getElementById('cancelmodal').click();
    document.getElementById('openModal1').click();
  }

  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].Casemanager.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });

        });

        this.arraycol[0].Casemanager.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (this.arraycol[0].Casemanager.ShowColumns.length != count1 || this.arraycol[0].Casemanager.HideColumns.length != count) {
          this.arraycol[0].Casemanager.ShowColumns = showarr;
          this.arraycol[0].Casemanager.HideColumns = hidearr;
        }
      }
    }
  }

  getSenderIdQualifier() {
    let params = new URLSearchParams();
    params.append("Code", "SENDERIDQUALIFIER");

    this.httpService.getSenderIdQualifier(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: DropList[]) => {
      this.senderidQualifier = data;
    })
  }

  getReceiver_id_qualifier() {
    let params = new URLSearchParams();
    params.append("Code", "RECEIVERID_QUALIFIER");

    this.httpService.getReceiver_id_qualifier(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: DropList[]) => {
      this.RecieveridQualifier = data;
    })
  }

  // ======================Set data to update=========================//
  selectCHDetails(CHDetails: ClearingHouseBO) {
    this.ClearH = JSON.parse(JSON.stringify(CHDetails));

    this.ModelType = 'edit';
    let params = new URLSearchParams();
    params.append("Id", CHDetails.id.toString());

    this.httpService.getClearingHousePayorMapping(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

    }, (err: any) => {
      if (err) {
        this.toastrService.error(err.error, 'Error'), 8000;
      }
    })
  }

  // Refresh Option //
  Refresh() {
    this.SearchText = "";
    this.CHSendBO.field = 'name';
    this.CHSendBO.value = "";
    this.CHSendBO.pageitem = 10;
    this.CHSendBO.currentpageno = 1;
    this.ClearingHouseFilterstatus = "Active"
    this.getClearingHouse();
    this.grid.clearFiltering();
    this.grid.clearSorting();
  }
  // ===============================Clearing house save and update=================== //

  SaveOrUpdateClearnhHouse() {
    this.isSaveorUpdateBoolean=true;
    this.ClearH.senderIDQualifierLid = (this.ClearH.senderIDQualifierLid);
    this.ClearH.receiverIDQualifierLid = (this.ClearH.receiverIDQualifierLid);
    this.httpService.saveupdate(this.ClearH).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.isSaveorUpdateBoolean=false;
      if (data) {
        //====================== sucess message =============
        if (this.ModelType == 'new') {
          this.ClearH.id = data;
          document.getElementById('openModal1').click();
          this.toastrService.success(
            "Clearing house saved successfully!"), 8000
        } else {
          document.getElementById('openModal1').click();
          this.toastrService.success(
            "Clearing house updated successfully!"), 8000
        }
        this.getClearingHouse();
      }
    },
      (Err: HttpErrorResponse) => {
        this.isSaveorUpdateBoolean=false;
        this.toastrService.error(Err.error, 'Error');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      })
  }
  // ===========================================Getting all data from DB=======================//
  getClearingHouse() {
    this.ngxService.start();
    this.gethttp.execute(this.CHSendBO);
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClearingDataList = data;
    })
  }
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].Clearinghouse.Columns;
    this.grid.columns.forEach(col => {
      this.arraycol[0].Clearinghouse.HideColumns.forEach(element => {
        if (col.headerText == element) {
          col.visible = false;
        }

      });
    });
    this.grid.hideColumns(this.arraycol[0].Clearinghouse.HideColumns);
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
    }
    this.grid.pageSettings.pageSize = this.arraycol[0].Clearinghouse.Pagesize;

    this.ColumnArray.forEach(element => {

      if (element.column == 'Name') {

        const column = this.grid.getColumnByField('name'); // get the JSON object of the column corresponding to the field name
        column.headerText = element.column;
        column.width = element.width;
        this.grid.refreshHeader();
      }

      if (element.column == 'Receiver Id Qualifier') {
        const column3 = this.grid.getColumnByField('receiverIDQualifier_Name'); // get the JSON object of the column corresponding to the field name
        column3.headerText = element.column;
        column3.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Receiver Id') {
        const column4 = this.grid.getColumnByField('receiverId'); // get the JSON object of the column corresponding to the field name
        column4.headerText = element.column;
        column4.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Sender Id Qualifier') {
        const column5 = this.grid.getColumnByField('senderIdQualifier_Name'); // get the JSON object of the column corresponding to the field name
        column5.headerText = element.column;
        column5.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Sender Id') {
        const column5 = this.grid.getColumnByField('senderId'); // get the JSON object of the column corresponding to the field name
        column5.headerText = element.column;
        column5.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Actions') {
        const column2 = this.grid.getColumnByUid('action'); // get the JSON object of the column corresponding to the field name
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();
      }
    });

  }

  CloseSaveMOdelConfirm() {
    if (this.valuechange.Id > 1 || this.valuechange.Name > 1
      || this.valuechange.SenderID > 1
      || this.valuechange.SenderIDQualifierLid > 1 || this.valuechange.ReceiverID > 1 || this.valuechange.ReceiverIDQualifierLid > 1) {
      document.getElementById('cancelmodal').click();
    }
    else {
      document.getElementById('openModal1').click();
    }
  }

  deleteClearingHousePayorMapping() {
    let params = new URLSearchParams();
    params.append("CleasingHousepayorId", this.deleteId);
    this.httpService.deleteClearingHousePayorMapping((this.deleteId)).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      document.getElementById("openModal3").click();
      this.toastrService.success(
        "Clearing house payor mapping deleted successfully!"), 8000
      const creds = this.clearHouseForm.controls.ClearingHousePayorMapping as FormArray;
      creds.removeAt(this.index);
    });
  }
  // =======================Grid Column selector ================ //
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

}
